import { View } from "react-native";
import StyledText from "./common/ui/styled-text";
import { Badge } from "./badge";
import { ShoppingBag, Star } from "lucide-react-native";

const UpsellCard = () => {
  return (
    <View className="border-2 border-dashed border-orange-200 bg-gradient-to-br from-orange-50 to-amber-50 flex flex-col rounded-lg py-6 relative">
      <View className="absolute -top-3 -right-2 z-10">
        <Badge
          variant="default"
          className="bg-orange-100 text-orange-800 border-orange-200 text-xs px-2 py-1 flex flex-row items-center gap-1"
        >
          <Star size={12} color="#f59e0b" />
          Premium Feature
        </Badge>
      </View>
      <View className="px-6">
        <View className="flex flex-row items-center justify-between mb-1">
          <StyledText className="text-sm font-semibold text-orange-800">
            Orders Placed
          </StyledText>
          <ShoppingBag size={20} color="#f59e0b" />
        </View>
        <StyledText className="text-2xl font-bold text-orange-800 mb-1">
          0
        </StyledText>
        <StyledText className="text-xs text-orange-800">
          Contact support for ordering.
        </StyledText>
      </View>
    </View>
  );
};

export default UpsellCard;
